'use client';

import { ProfileSidebarItem } from '@eliadmin/core/src/components/profile/profile-sidebar-item';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useLocalePathname } from '@eliadmin/core/src/hooks/use-locale-pathname';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import {
  MdLockOutline,
  MdLogout,
  MdOutlineAccountCircle,
  MdOutlineWorkspacePremium,
} from 'react-icons/md';
import { RiAccountCircleLine } from 'react-icons/ri';
import { TfiPackage } from 'react-icons/tfi';

export type SidebarItem = {
  name: string;
  icon: string;
  href: string | (() => string);
  hardLink?: true;
  variant?: 'destructive';
};

export type ProfileSidebarProps = {
  sidebarItems?: SidebarItem[];
  className?: {
    root?: string;
  };
};

export function ProfileSidebar({ className }: ProfileSidebarProps) {
  const pathname = useLocalePathname();
  const templateSettings = useGlobalStore(state => state.templateSettings);
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'mx-auto flex w-full flex-col gap-2 sm:max-w-[450px] sm:gap-3',
        'ea-sidebar',
        className?.root,
      )}
    >
      {!!templateSettings.profile?.profile_info?.enabled && (
        <ProfileSidebarItem
          name={t('text491')}
          icon={<MdOutlineAccountCircle size={26} className="text-black" />}
          href={() => ROUTES.MY_DATA()}
          pathname={pathname}
        />
      )}
      {!!templateSettings.profile?.orders?.enabled && (
        <ProfileSidebarItem
          name={t('text2361')}
          icon={<TfiPackage size={26} className="text-black" />}
          href={() => ROUTES.ORDERS()}
          pathname={pathname}
        />
      )}
      {!!templateSettings.profile?.change_password?.enabled && (
        <ProfileSidebarItem
          name={t('text115')}
          icon={<MdLockOutline size={26} className="text-black" />}
          href={() => ROUTES.CHANGE_PASSWORD()}
          pathname={pathname}
        />
      )}
      {!!templateSettings.profile?.sign_out?.enabled && (
        <ProfileSidebarItem
          name={t('text258')}
          icon={<MdLogout size={26} className="text-[#666666]" />}
          href={() => ROUTES.SIGN_OUT()}
          hardLink
          variant="destructive"
          pathname={pathname}
        />
      )}
    </div>
  );
}
